import { isComplexEntityType } from "../../../../../../../utils/utils";
import {
  addToAssetColumn,
  getAffectedEntityInfoIconColumn,
  getDisplayNameColumn,
  getExtraInfoColumn,
  getFirstDiscoveredColumn,
  getLabelColumn,
  getSimpleEntityDisplayNameColumn,
  getThirdInfoColumn,
} from "../../shared/sharedColumns";
import { MisconfigStatusTab } from "../../tables/MisconfigStatusTabs";

export default function getAffectedEntitiesTableColumns(
  misconfiguration,
  entityType,
  selectedExclusionTab,
  colors,
  terminatedEntities
) {
  const addColumnsForComplexEntities = (columns, terminatedEntities) => {
    columns.push(addToAssetColumn);
    columns.push(getDisplayNameColumn(colors, terminatedEntities));
    columns.push(getExtraInfoColumn(entityType, colors));
    const thirdColumn = getThirdInfoColumn(entityType, colors);
    if (thirdColumn) {
      columns.push(thirdColumn);
    }
    if (
      selectedExclusionTab === MisconfigStatusTab.EXCLUDED ||
      selectedExclusionTab === MisconfigStatusTab.SNOOZED
    ) {
      columns.push(getAffectedEntityInfoIconColumn(misconfiguration));
    }
  };

  const addColumnsForSimpleEntities = (columns) => {
    columns.push(getSimpleEntityDisplayNameColumn(colors));
    if (
      selectedExclusionTab === MisconfigStatusTab.EXCLUDED ||
      selectedExclusionTab === MisconfigStatusTab.SNOOZED
    ) {
      columns.push(getAffectedEntityInfoIconColumn(misconfiguration));
    }
  };

  const columns = [];
  if (isComplexEntityType(entityType))
    addColumnsForComplexEntities(columns, terminatedEntities);
  else addColumnsForSimpleEntities(columns);

  columns.push(
    getFirstDiscoveredColumn(colors, (params) => {
      const affectedEntity = misconfiguration.affected_entities?.find(
        (ae) => ae.entity_id === params.row.entity_id
      );
      return affectedEntity?.first_seen?.timestamp_utc || 0;
    })
  );

  columns.push(getLabelColumn());
  return columns;
}
